import isNil from 'lodash-es/isNil';

import {
  getCarData,
  setMessageVisibility,
  getFormValue,
  getIsMotorFromSelector,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum, MessagesEnum } from 'app/shared/enums';
import {
  isPersonalDataTwoAdvantagesView,
  isPersonalDataWithoutEncouragementView,
} from 'app/shared/helpers/personalDataViewByDevice';
import { isValidCarRegistrationNumber } from 'app/validators/validateCarRegistrationNumber';

export function setPersonalDataMessage() {
  const shouldHideBasePersonalDataMessages =
    isPersonalDataWithoutEncouragementView() ||
    isPersonalDataTwoAdvantagesView();
  const isMotor = getIsMotorFromSelector();
  const { registrationNumber } = getCarData();
  const isAnonymized = (registrationNumber || '').includes('***');
  const isEmpty = registrationNumber === '' || isNil(registrationNumber);
  const isValid = isValidCarRegistrationNumber(registrationNumber);
  const showMorePersonalData = getFormValue(FieldsEnum.PersonalDataPath);

  setMessageVisibility({
    key: MessagesEnum.PersonalData,
    visible:
      !shouldHideBasePersonalDataMessages &&
      showMorePersonalData !== false &&
      ((!isEmpty && isValid) || isAnonymized),
    formName: FormsEnum.CalculationForm,
  });

  setMessageVisibility({
    key: MessagesEnum.PersonalDataNotProvided,
    visible:
      !shouldHideBasePersonalDataMessages &&
      showMorePersonalData === false &&
      ((!isEmpty && isValid) || isAnonymized) &&
      !isMotor,
    formName: FormsEnum.CalculationForm,
  });

  setMessageVisibility({
    key: MessagesEnum.PersonalDataWithoutCarRegistrationNumber,
    visible:
      !shouldHideBasePersonalDataMessages &&
      showMorePersonalData !== false &&
      (isEmpty || !isValid),
    formName: FormsEnum.CalculationForm,
  });

  setMessageVisibility({
    key: MessagesEnum.PersonalDataNotProvidedWithoutCarRegistrationNumber,
    visible:
      !shouldHideBasePersonalDataMessages &&
      showMorePersonalData === false &&
      (isEmpty || !isValid || isMotor),
    formName: FormsEnum.CalculationForm,
  });
}
